var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all-set"},[_c('h1',[_vm._v(_vm._s(_vm.$t('verification.thanks')))]),_c('h2',{staticClass:"subtitle"},[_vm._v(" "+_vm._s(_vm.$t('verification.we-will-contact-you'))+" ")]),_c('v-btn',{staticClass:"button done-button",on:{"click":_vm.done}},[_vm._v(_vm._s(_vm.$t('verification.done')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }